import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { FadModulesModel } from 'models/ferramentaAutoria/FadModulesModel';
import styled from 'styled-components';
import { FadContentsModel } from 'models/ferramentaAutoria/FadContentsModel';
import { FadContentsService } from 'core/http/service/ferramentaAutoria/FadContents.service';
import { ToastSuccess } from 'components/Toaster';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;

        h2 {
            font-family: 'Barlow';
            font-size: 20px;
        }

        span {
            font-weight: 600;
        }
    `,

    Button: styled.button`
        width: 100%;
        padding: 12px 16px;
        background-color: #f0f0f0;
        border: none;
        font-size: 18px;
        font-weight: 600;

        :hover {
            background-color: #d9d9d9;
        }
    `,
};

interface IModalTranferContent {
    listModules?: FadModulesModel[];
    content: FadContentsModel;
    open: boolean;
    handleClose: () => void;
    handleRefresh: () => void;
}

const service = new FadContentsService();

export const ModalTranferContent: React.FC<IModalTranferContent> = ({ listModules, content, open, handleClose, handleRefresh }) => {
    const updateContentModule = async (moduleCodigo: number) => {
        // Lógica para atualizar o módulo do conteúdo
        const codigoModule = moduleCodigo;
        const codigoContent = content.codigo;

        // Chamar o serviço para atualizar o módulo do conteúdo
        // Exemplo: await fadContentsService.transferContentModule(codigoContent, codigoModule);

        try {
            await service.transferContentModule(codigoContent, codigoModule);
            // Fechar o modal após a transferência
            ToastSuccess('Conteúdo transferido com sucesso!');

            handleClose();
            // Atualizar a lista de conteúdos ou módulos, se necessário
            handleRefresh();
        } catch (error) {
            console.error('Erro ao transferir conteúdo:', error);
        }
    };

    return (
        <Modal visible={open} onCancel={handleClose} footer={null}>
            <Styled.Container>
                <h2>
                    Transferir <span>( {content.title} )</span> para outro módulo:
                </h2>

                {listModules
                    ?.filter(m => m.codigo !== content.codigoFerramentaAutoriaModule)
                    ?.map(module => (
                        <Styled.Button key={module.codigo} onClick={() => updateContentModule(module.codigo)}>
                            <p>{module.title}</p>
                        </Styled.Button>
                    ))}
            </Styled.Container>
        </Modal>
    );
};
